import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgxEchartsDirective } from 'ngx-echarts';
import type { EChartsOption } from 'echarts';
import { PerformanceComparison } from '../../models';
import {
  CHART_AXIS_LINE,
  CHART_LABEL_MEDIUM,
  CHART_LEGEND_TEXT_STYLE,
  CHART_SPLIT_LINE,
  CHART_TOOLTIP,
} from '../../../../shared/ui/charts/chart-theme';

@Component({
  selector: 'app-performance-chart',
  imports: [NgxEchartsDirective, MatIconModule],
  template: `
    <div class="bg-pmdf-surface rounded-pmdf-card shadow-pmdf-card p-4">
      <div class="flex items-center gap-2 mb-3">
        <mat-icon class="icon-base text-pmdf-primary">show_chart</mat-icon>
        <h3 class="text-sm font-semibold text-pmdf-text-primary">Desempenho Comparativo</h3>
      </div>
      <div echarts [options]="chartOptions()" class="h-64 w-full"></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerformanceChart {
  data = input.required<PerformanceComparison>();

  chartOptions = computed<EChartsOption>(() => {
    const d = this.data();
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        ...CHART_TOOLTIP,
      },
      legend: {
        data: ['Você', 'Unidade', 'PMDF'],
        bottom: 0,
        textStyle: CHART_LEGEND_TEXT_STYLE,
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 16,
      },
      grid: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 40,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: d.categories,
        axisLabel: { color: CHART_LABEL_MEDIUM, fontSize: 10 },
        axisLine: { lineStyle: { color: CHART_AXIS_LINE } },
        axisTick: { show: false },
      },
      yAxis: {
        type: 'value',
        axisLabel: { color: CHART_LABEL_MEDIUM, fontSize: 10 },
        splitLine: { lineStyle: { color: CHART_SPLIT_LINE, type: 'dashed' } },
        axisLine: { show: false },
      },
      series: [
        {
          name: 'Você',
          type: 'bar',
          data: d.series.policial,
          barWidth: 10,
          itemStyle: { color: '#60a5fa', borderRadius: [3, 3, 0, 0] },
        },
        {
          name: 'Unidade',
          type: 'bar',
          data: d.series.unidade,
          barWidth: 10,
          itemStyle: { color: '#4ade80', borderRadius: [3, 3, 0, 0] },
        },
        {
          name: 'PMDF',
          type: 'bar',
          data: d.series.pmdf,
          barWidth: 10,
          itemStyle: { color: '#f87171', borderRadius: [3, 3, 0, 0] },
        },
      ],
    };
  });
}
